import React from 'react';
import Style from '../Styles/PaymentMethodsComponentStyle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

export default function OrdersEmailComponent(props) {
  const classes = Style();
    const setOrdersEmail = (e) => {
        componentMethods.setManagerState({ordersEmail: e.target.value})
    }
    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

  return (<div className={classes.ordersObservationsInput}>
    <Grid container spacing={3}>
        <Grid item xs={12} lg={12} md={112}>
            <TextField fullWidth id="standard-basic" label={componentConstants.language.LANG_ORDER_EMAIL} aria-label="orderObservations" name="orderObservations" value={componentMethods.getManagerState().ordersEmail} onChange={setOrdersEmail } />
        </Grid>
    </Grid>
    </div>
  );
}